import { Button, Link } from "../Actions";
import styles from "./CongressEmailContent.module.css";

export const CongressEmailContent = ({
  legislator,
  senderName,
  senderAddress
}: any) => {
  const emailText = `Dear Rep. ${legislator.bio.first_name} ${
    legislator.bio.last_name
  },\n\nI am writing to you as a concerned constituent who firmly believes in
  the potential of cryptocurrencies as a catalyst for economic growth and
  innovation in our great nation. I urge you to support the adoption and
  integration of cryptocurrencies into the American financial system for
  the following reasons:
  \nEconomic Growth: Cryptocurrencies provide an opportunity for businesses
  and individuals to transact without intermediaries, reducing transaction
  costs and promoting economic growth. This is especially true for small
  businesses and start-ups, which can benefit from lower costs and
  increased accessibility to capital.
  \nFinancial Inclusion: Cryptocurrencies can provide access to financial
  services for millions of unbanked or underbanked Americans, offering a
  secure and cost-effective way to store and transfer wealth.
  \nInnovation: The underlying technology of cryptocurrencies, blockchain,
  has a wide array of applications beyond finance. By supporting the
  adoption of cryptocurrencies, we foster innovation in sectors such as
  supply chain management, healthcare, and data storage.
  \nGlobal Competitiveness: Many countries are actively embracing
  cryptocurrency and blockchain technologies, and the United States must
  not be left behind. Supporting this technology will ensure that our
  nation remains competitive on the global stage.
  \nI understand that there are concerns surrounding cryptocurrencies, such
  as fraud and illicit activities. However, with appropriate regulation
  and oversight, we can address these issues while still promoting the
  growth and adoption of this transformative technology.\n
  Thank you for your time and consideration.\nSincerely,\n
  ${senderName},\n${senderAddress
    .split(", ")
    .slice(0, -1)
    .map((part: string, index: number, arr: string[]) => {
      return `${part}${index + 1 < arr.length ? ",\n" : ""}`;
    })
    .join("")}`;

  return (
    <>
      <div className={`${styles.emailContainer} whitespace-pre-line`}>
        {emailText}
      </div>
      <div className="grid grid-cols-2 gap-2 text-center">
        <Button
          analyticsProperty="email subscribe"
          modifier="secondary"
          type="submit"
          className="w-full text-right"
          onClick={() => {
            navigator.clipboard.writeText(emailText)
          }}>
          Copy Email
        </Button>
        <Link
          modifier="primary"
          analyticsProperty="Contact Your Rep"
          href={legislator.contact.url}>
          Contact Your Rep
        </Link>
      </div>
    </>
  );
};
